<template>
  <SkeletonLoader show-animation>
    <div class="loading-skeleton__title" />
    <div class="loading-skeleton__filters" />
    <div v-for="index in 5" :key="index" class="loading-skeleton__item" />
  </SkeletonLoader>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class DetailLoader extends Vue {}
</script>
<style lang="less" scoped>
.loading-skeleton {
  &__title {
    height: @size-spacing-x800;
    border-radius: 12px;
    width: 40%;
  }

  &__filters {
    width: 75%;
    height: @size-spacing-x600;
    border-radius: 8px;
    margin: @size-spacing-x800 0 @size-spacing-x600 0;
  }

  &__item {
    height: @size-spacing-x800;
    width: 100%;
    border-radius: 8px;
    margin-bottom: @size-spacing-x500;
  }
}
</style>
